export const shouldPrintReceiptPricesByDefault = (supplierName?: string | null): boolean =>
  supplierName?.trim().toLocaleLowerCase('uk') !== '\u0435\u0434\u0456\u043a';
